export default {
  title: 'Phí đồng thanh toán',
  description: 'Phí đồng thanh toán là một khoản tiền cụ thể mà bạn phải trả cho các dịch vụ chăm sóc sức khỏe hoặc đơn thuốc được bảo hiểm chi trả, theo quy định của kế hoạch bảo hiểm của bạn.',
  'is-paid': 'đã thanh toán',
}
